import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1076.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1076.000000) scale(0.100000,-0.100000)">
        <path d="M5240 8204 c-511 -43 -862 -146 -1287 -379 -315 -172 -673 -491 -905
-806 -138 -187 -288 -467 -361 -674 -57 -161 -107 -355 -131 -505 -58 -365
-40 -738 53 -1100 178 -695 601 -1256 1251 -1659 344 -215 677 -338 1107 -413
177 -31 662 -33 848 -4 507 78 974 275 1386 584 403 302 751 749 916 1176 91
235 148 477 174 736 18 175 6 501 -25 675 -25 148 -59 289 -80 340 -7 16 -16
46 -20 66 -15 81 -138 363 -230 527 -20 34 -81 128 -137 208 -321 459 -791
828 -1314 1029 -237 91 -440 143 -688 176 -143 19 -454 32 -557 23z m485 -85
c589 -67 1120 -296 1544 -664 71 -61 292 -284 341 -344 242 -293 426 -650 517
-999 160 -621 107 -1229 -156 -1777 -169 -353 -394 -641 -706 -906 -22 -19
-42 -37 -45 -40 -24 -28 -269 -197 -376 -259 -748 -435 -1627 -514 -2424 -216
-386 145 -703 347 -1011 643 -256 247 -458 540 -617 893 -61 136 -122 354
-164 580 -20 111 -23 156 -22 395 0 228 3 289 21 395 59 343 152 612 309 895
55 99 214 334 252 373 9 10 45 50 80 89 52 59 159 167 256 258 80 75 277 217
443 318 78 47 241 128 347 171 423 174 955 247 1411 195z"/>
<path d="M5438 7854 c21 -28 21 -34 12 -223 -10 -198 -14 -231 -31 -231 -5 0
-9 -4 -9 -10 0 -6 30 -10 71 -10 l70 0 -15 22 c-11 15 -16 45 -16 89 0 82 11
189 19 188 8 0 57 -73 142 -211 l72 -118 48 0 c49 0 49 0 49 33 0 17 7 113 15
212 8 99 15 188 15 198 0 9 9 26 19 36 11 11 17 22 14 25 -4 3 -36 6 -72 6
-50 0 -62 -3 -53 -12 20 -20 9 -265 -13 -287 -9 -9 -29 20 -120 174 l-80 135
-62 0 c-34 0 -69 3 -79 7 -14 5 -14 2 4 -23z"/>
<path d="M5033 7851 c-67 -24 -89 -40 -121 -88 -25 -35 -27 -46 -27 -143 0
-89 3 -111 22 -146 67 -125 210 -165 338 -96 66 36 103 91 116 171 24 149 -42
269 -167 307 -62 18 -98 17 -161 -5z m117 -66 c50 -26 73 -85 78 -201 4 -100
4 -102 -25 -134 -23 -25 -37 -33 -62 -32 -76 2 -121 74 -129 206 -6 93 11 135
62 160 39 19 41 19 76 1z"/>
<path d="M6040 7775 c0 -18 -6 -58 -14 -87 -33 -126 -87 -315 -96 -335 -8 -20
-6 -23 28 -32 221 -58 254 -61 324 -28 92 42 147 135 148 250 0 71 -19 126
-56 158 -35 31 -119 66 -206 88 -121 29 -128 29 -128 -14z m210 -84 c73 -36
87 -136 33 -249 -32 -69 -83 -97 -157 -88 -27 3 -53 9 -57 13 -6 6 47 214 87
341 4 15 42 8 94 -17z"/>
<path d="M4640 7776 l-55 -22 4 -162 c2 -98 0 -162 -6 -162 -8 0 -60 54 -194
203 l-36 40 -69 -28 c-38 -16 -70 -29 -71 -30 -2 -1 19 -46 46 -101 53 -108
101 -211 120 -260 16 -40 11 -88 -9 -92 -9 -1 -58 26 -109 60 -51 35 -131 88
-177 118 -46 30 -102 68 -124 84 l-40 29 -37 -28 c-21 -16 -39 -30 -41 -31 -2
-1 18 -60 43 -131 99 -271 115 -319 115 -355 0 -21 3 -38 8 -38 4 0 25 16 46
35 l40 34 -27 49 c-15 28 -27 58 -27 67 0 18 6 24 71 70 l37 26 46 -28 c25
-15 49 -36 52 -46 3 -10 9 -17 13 -15 34 15 231 120 231 123 0 2 -9 21 -19 42
-29 57 -112 246 -109 249 2 1 32 -25 68 -57 82 -75 191 -159 208 -159 13 0 16
58 12 233 -1 48 2 87 7 87 14 0 66 -119 104 -235 7 -22 14 -41 15 -43 2 -4
127 19 133 24 2 2 -3 12 -12 22 -25 27 -167 393 -167 430 0 28 -18 28 -90 -2z
m-617 -536 c63 -38 70 -55 32 -72 -14 -6 -25 -15 -25 -20 0 -4 -6 -8 -14 -8
-11 0 -66 113 -66 136 0 8 6 5 73 -36z"/>
<path d="M6741 7494 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6685 7399 c-11 -16 -1 -19 13 -3 7 8 8 14 3 14 -5 0 -13 -5 -16 -11z"/>
<path d="M3567 7173 l-45 -42 158 -157 c88 -86 166 -172 175 -191 18 -38 20
-38 87 25 l47 44 -57 52 c-31 28 -116 109 -189 181 l-132 130 -44 -42z"/>
<path d="M7115 7100 c-8 -13 5 -13 25 0 13 8 13 10 -2 10 -9 0 -20 -4 -23 -10z"/>
<path d="M6992 6924 c10 -10 20 -16 22 -13 3 3 -5 11 -17 18 -21 13 -21 12 -5
-5z"/>
<path d="M7033 6914 c0 -14 0 -24 1 -22 1 2 7 10 14 19 10 14 10 18 -1 22 -10
4 -14 -2 -14 -19z"/>
<path d="M3385 6923 c-24 -6 -92 -58 -120 -92 -11 -13 -37 -47 -58 -75 -21
-28 -45 -59 -53 -69 -17 -21 -18 -37 -1 -37 20 0 343 -218 395 -267 21 -20 26
-16 60 35 17 26 44 61 60 77 49 52 83 114 89 164 11 95 -79 219 -184 255 -44
15 -143 20 -188 9z m155 -124 c96 -48 135 -147 92 -229 -34 -62 -38 -61 -180
39 -175 123 -170 117 -135 153 64 67 139 80 223 37z"/>
<path d="M6760 6923 c0 -8 33 -32 44 -33 5 0 3 6 -3 13 -6 8 -9 16 -6 18 2 3
-5 5 -15 6 -11 1 -20 -1 -20 -4z"/>
<path d="M4633 6863 c-43 -40 -116 -101 -271 -226 -138 -111 -424 -348 -452
-374 -13 -13 -11 -18 20 -45 93 -82 474 -443 629 -595 77 -76 83 -85 69 -99
-14 -14 -25 -12 -123 20 -58 20 -122 36 -141 36 -19 0 -34 4 -34 8 0 4 -55 25
-122 46 -68 22 -139 46 -158 54 -19 9 -44 15 -55 14 -10 0 -25 4 -32 10 -8 6
-38 8 -82 3 -73 -7 -115 4 -105 29 4 11 -7 14 -55 12 -56 -2 -79 6 -48 17 6 2
-10 4 -38 4 -54 0 -134 18 -150 34 -7 7 -4 10 10 7 11 -1 24 -7 28 -13 5 -6 7
-4 5 5 -6 20 -80 39 -86 22 -2 -7 -8 -10 -13 -6 -19 11 18 31 51 28 31 -3 32
-2 10 5 -14 5 -40 9 -58 10 -18 1 -31 5 -27 10 3 6 -5 9 -17 9 -51 -3 -88 3
-88 13 0 10 12 9 67 -6 10 -3 2 2 -17 11 -19 9 -59 23 -88 30 -47 12 -55 12
-68 -1 -13 -13 -12 -14 13 -9 36 7 76 -20 53 -36 -24 -15 -37 -11 -16 5 19 14
18 15 -12 15 -22 0 -32 -5 -32 -15 0 -17 -25 -20 -35 -5 -3 6 -21 10 -40 10
-42 0 -85 19 -85 37 0 7 -8 13 -19 13 -10 0 -24 6 -30 14 -8 9 -26 13 -54 10
l-42 -5 35 14 c34 13 66 7 80 -14 3 -4 19 -11 35 -14 28 -7 29 -6 11 7 -10 8
-16 19 -13 25 11 17 -127 38 -165 25 -30 -9 -29 -10 17 -5 35 4 47 2 40 -5 -5
-6 -21 -12 -34 -14 -30 -4 -39 -25 -14 -31 15 -4 14 -5 -3 -6 -12 0 -25 7 -28
16 -26 66 -70 -151 -85 -412 -20 -348 33 -668 166 -1000 66 -166 84 -203 165
-338 134 -225 247 -371 409 -529 381 -372 876 -629 1403 -729 271 -51 700 -50
981 2 295 54 640 181 870 318 28 17 64 38 80 47 42 24 187 127 270 193 107 84
334 314 418 422 73 96 187 262 187 274 0 4 8 19 19 33 72 103 202 417 250 607
76 303 89 684 33 980 l-17 90 -32 3 c-18 2 -60 -4 -94 -12 -78 -20 -147 -21
-170 -1 -15 14 -23 14 -81 1 -35 -8 -113 -31 -172 -51 -59 -19 -112 -32 -118
-29 -8 5 -5 10 8 15 16 6 15 8 -8 8 -15 1 -29 -3 -33 -8 -3 -6 -13 -10 -23 -9
-31 0 -147 -39 -132 -45 12 -4 11 -6 -3 -6 -10 -1 -25 -8 -33 -16 -11 -11 -26
-13 -56 -8 -29 4 -39 3 -34 -5 4 -6 14 -9 24 -6 13 4 13 3 -2 -7 -30 -19 -81
-27 -100 -17 -10 6 -29 7 -44 3 -21 -5 -23 -8 -11 -16 10 -7 7 -8 -11 -4 -14
3 -43 -1 -65 -9 l-40 -15 35 -1 c28 -1 31 -3 15 -9 -11 -5 -33 -4 -48 2 -23 8
-31 6 -42 -9 -7 -10 -12 -21 -10 -24 2 -3 -11 -6 -28 -7 l-32 -1 28 11 c39 16
33 27 -8 15 -19 -6 -32 -14 -30 -19 3 -4 -2 -9 -10 -12 -9 -4 -12 -1 -9 8 5
11 -5 10 -43 -5 -26 -11 -82 -29 -123 -41 -41 -11 -117 -34 -167 -51 -88 -29
-123 -31 -123 -8 0 18 60 80 294 305 18 17 88 82 156 145 68 63 131 122 140
130 9 8 44 40 77 71 l62 57 -107 89 c-129 109 -240 201 -306 257 -28 22 -68
57 -91 76 -23 19 -64 53 -91 75 -64 53 -148 128 -152 138 -2 4 -340 7 -751 7
l-748 0 -30 -27z m647 -43 c0 -5 -4 -10 -8 -10 -5 0 -35 -16 -68 -37 -32 -20
-106 -64 -164 -99 -58 -34 -120 -72 -138 -83 -18 -12 -37 -21 -42 -21 -18 0
-165 242 -154 253 11 11 574 8 574 -3z m840 3 c0 -3 -17 -32 -37 -63 -21 -32
-58 -90 -82 -129 -24 -39 -47 -71 -52 -71 -13 0 -429 251 -429 259 0 4 135 7
300 8 165 0 300 -2 300 -4z m-641 -58 c40 -25 75 -45 77 -45 2 0 67 -39 146
-86 79 -48 156 -94 173 -103 16 -9 33 -20 37 -25 8 -12 -135 -220 -153 -223
-8 -2 -90 69 -184 156 l-169 159 -36 -30 c-19 -17 -84 -77 -145 -133 -162
-151 -173 -159 -189 -146 -27 22 -148 209 -142 219 3 5 86 56 183 113 98 57
201 117 228 133 87 53 90 55 95 55 3 1 39 -19 79 -44z m-940 -72 c-79 -74
-242 -240 -357 -364 -51 -55 -54 -57 -115 -61 -34 -3 -63 -4 -65 -3 -7 6 189
177 301 265 39 30 98 77 131 103 101 79 178 137 184 137 2 0 -33 -35 -79 -77z
m1908 -240 c123 -136 152 -171 146 -177 -3 -3 -72 -6 -152 -6 -171 0 -145 -12
-325 148 -131 117 -125 93 -53 212 21 36 50 80 63 97 l25 33 131 -135 c72 -74
146 -152 165 -172z m-1736 240 c18 -32 44 -76 59 -98 46 -69 50 -62 -100 -194
l-138 -121 -156 0 c-86 0 -156 4 -156 8 0 20 432 462 451 462 4 0 22 -26 40
-57z m1709 -103 c30 -25 60 -48 65 -52 24 -18 224 -185 265 -222 66 -59 66
-61 -1 -58 l-59 4 -160 173 c-88 95 -191 202 -230 238 -89 83 -91 98 -2 20 37
-32 92 -78 122 -103z m-878 -181 c69 -63 129 -120 132 -126 4 -10 -53 -11
-267 -7 -150 3 -273 7 -275 9 -8 7 260 245 273 241 6 -1 67 -54 137 -117z
m-631 -31 c35 -51 66 -96 67 -100 2 -4 -80 -8 -183 -8 -103 0 -185 4 -183 9 3
9 220 189 229 190 3 1 35 -40 70 -91z m1166 -4 c53 -46 100 -84 104 -84 5 0 9
-4 9 -10 0 -6 -67 -10 -180 -10 -104 0 -180 4 -180 9 0 13 99 164 118 178 19
15 13 19 129 -83z m-1870 -230 c99 -101 197 -212 201 -227 2 -8 1 -8 -5 -2 -7
9 -65 56 -127 105 -11 8 -40 33 -65 56 -25 22 -76 64 -113 93 -38 29 -68 54
-68 55 0 1 22 2 49 1 48 -1 51 -3 128 -81z m2573 77 c0 -6 -32 -36 -72 -68
-39 -32 -104 -85 -144 -118 -120 -99 -195 -157 -200 -153 -2 2 72 82 164 176
165 171 168 173 210 172 23 0 42 -4 42 -9z m-2212 -68 c45 -99 139 -343 147
-378 7 -35 -30 38 -80 160 -46 110 -93 215 -98 215 -4 0 66 -212 103 -313 12
-32 19 -61 16 -65 -8 -7 -436 423 -436 438 0 6 60 10 159 10 l158 0 31 -67z
m390 52 c1 -1 -22 -42 -53 -90 -30 -48 -60 -103 -67 -121 -7 -19 -14 -34 -18
-34 -11 0 -210 237 -210 252 0 4 344 -3 348 -7z m1236 7 c2 -4 -23 -40 -57
-79 -34 -39 -81 -94 -105 -122 -24 -28 -47 -49 -51 -46 -10 5 -161 231 -161
239 0 3 80 7 178 9 97 1 180 4 184 5 4 1 9 -2 12 -6z m406 -2 c0 -11 -132
-142 -336 -335 -76 -71 -134 -121 -130 -110 104 266 158 416 152 422 -9 9 -31
-37 -96 -203 -78 -198 -111 -273 -122 -274 -4 0 5 35 21 78 16 42 32 86 36 97
27 76 81 211 107 268 l31 67 168 0 c105 0 169 -4 169 -10z m-912 -13 c-25 -23
-123 -104 -171 -141 -48 -35 -50 -36 -143 -36 l-94 0 -97 95 -98 94 308 1
c249 0 306 -2 295 -13z m-559 -85 c45 -41 81 -79 81 -86 0 -6 -21 -33 -47 -58
l-48 -47 -105 11 c-58 7 -107 13 -109 14 -2 2 6 19 18 38 25 40 74 126 98 174
9 18 20 31 24 30 4 -2 44 -36 88 -76z m710 -41 l79 -118 -98 -37 c-54 -20
-105 -36 -112 -36 -7 0 -47 34 -88 76 l-75 75 30 22 c16 12 59 48 95 79 36 32
70 58 77 58 7 0 48 -53 92 -119z m-546 -158 c15 -43 27 -88 27 -100 0 -12 5
-25 10 -28 16 -10 -3 -29 -61 -65 -38 -23 -49 -26 -49 -14 0 8 -9 24 -19 36
-11 11 -30 45 -42 75 l-22 55 59 59 c32 32 61 58 64 59 3 0 18 -35 33 -77z
m265 40 c11 -10 38 -39 61 -65 l42 -47 -22 -43 c-12 -24 -30 -55 -41 -70 -21
-31 -22 -31 -100 18 l-36 23 29 83 c16 46 29 91 29 101 0 9 4 17 9 17 5 0 18
-8 29 -17z m-2598 -13 c0 -13 -11 -13 -30 0 -12 8 -11 10 8 10 12 0 22 -4 22
-10z m2955 -48 c-27 -23 -204 -179 -232 -203 -46 -41 -63 -36 -22 7 46 48 239
204 252 204 7 0 7 -3 2 -8z m1610 -62 c-3 -5 -13 -10 -20 -10 -8 0 -43 -15
-77 -33 -35 -18 -72 -36 -83 -40 -11 -3 -27 -11 -35 -17 -42 -28 -276 -116
-455 -170 -33 -10 -107 -34 -165 -54 -234 -79 -341 -109 -350 -100 -5 5 -11
25 -12 43 l-3 34 215 62 c118 35 253 74 300 88 104 32 475 141 550 163 30 8
69 21 85 29 36 16 58 19 50 5z m-245 -10 c0 -5 -7 -10 -15 -10 -8 0 -15 5 -15
10 0 6 7 10 15 10 8 0 15 -4 15 -10z m-2230 -62 c30 -28 46 -46 35 -40 -28 16
-111 92 -100 92 6 -1 35 -24 65 -52z m2157 46 c-3 -3 -12 -4 -19 -1 -8 3 -5 6
6 6 11 1 17 -2 13 -5z m-3450 -70 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17
-2 13 -5z m3180 -10 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z
m-2912 -44 c3 -5 2 -10 -4 -10 -5 0 -13 5 -16 10 -3 6 -2 10 4 10 5 0 13 -4
16 -10z m1472 -34 c117 -59 226 -101 348 -133 83 -21 129 -27 273 -31 173 -5
191 -9 160 -40 -10 -10 -15 -86 -19 -275 -8 -318 -21 -406 -95 -626 -33 -98
-96 -239 -113 -251 -4 -3 -20 -31 -35 -62 -84 -168 -281 -353 -514 -483 l-102
-57 -67 37 c-177 98 -384 274 -426 363 -5 12 -14 22 -19 22 -4 0 -8 8 -7 18 0
10 3 12 6 5 2 -7 12 -13 21 -13 13 0 12 3 -4 19 -13 12 -21 15 -26 7 -9 -14
-39 24 -33 41 2 7 -2 10 -11 6 -8 -3 -14 1 -14 8 0 7 -6 20 -14 28 -36 42
-148 283 -174 376 -47 170 -72 391 -72 645 0 135 -2 150 -21 174 -12 15 -20
29 -18 31 2 1 69 8 149 14 230 18 447 77 632 171 51 26 96 48 100 49 4 0 46
-19 95 -43z m-2086 -155 c145 -27 284 -52 309 -56 25 -4 167 -29 315 -57 149
-27 303 -55 344 -62 46 -7 76 -17 79 -25 4 -11 -4 -13 -34 -7 -22 3 -70 11
-109 16 -38 5 -158 25 -265 45 -107 20 -222 40 -255 45 -33 6 -100 17 -150 25
-459 79 -496 83 -517 61 -9 -8 -21 -48 -27 -88 -6 -40 -16 -98 -22 -128 -5
-30 -14 -95 -19 -145 -9 -87 -42 -350 -58 -467 -9 -57 -22 -90 -22 -52 0 10
12 129 25 264 14 135 30 290 35 345 14 147 29 265 36 287 4 15 40 39 70 48 1
0 120 -22 265 -49z m84 -256 c77 -14 147 -26 155 -28 21 -5 24 -39 11 -142
-21 -157 -16 -147 -69 -140 -140 19 -300 47 -321 56 -20 8 -22 14 -16 42 6 31
34 214 35 230 0 12 59 7 205 -18z m-170 -410 c74 -10 85 -14 85 -37 0 -20 -4
-20 -65 -14 -113 11 -125 16 -125 43 0 21 3 24 28 19 15 -3 50 -8 77 -11z
m279 -45 c5 -5 6 -16 2 -25 -5 -14 -14 -16 -54 -10 -80 11 -92 16 -92 37 0 18
5 19 68 13 37 -4 71 -11 76 -15z m251 -25 c50 -8 93 -15 98 -15 10 0 9 -32 -2
-48 -6 -11 -29 -10 -124 5 -117 18 -117 18 -117 45 0 34 12 35 145 13z m300
-45 c132 -18 140 -21 116 -59 -7 -11 -25 -12 -107 -2 -128 16 -134 18 -134 45
0 28 9 38 29 32 9 -3 52 -10 96 -16z m299 11 c3 -5 15 -7 26 -4 12 3 21 0 22
-8 3 -29 7 -42 29 -98 10 -23 10 -23 -51 -19 -36 3 -65 10 -70 17 -7 12 -4 78
6 109 4 14 30 16 38 3z m-989 -171 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6
2 10 4 10 3 0 8 -4 11 -10z m1067 -90 c16 -7 24 -18 21 -26 -3 -8 6 -18 23
-25 16 -6 23 -13 17 -16 -10 -3 -10 -10 -2 -25 11 -21 11 -21 -97 -15 -59 4
-112 11 -117 16 -4 4 -5 32 -1 61 l7 53 61 -6 c34 -2 73 -10 88 -17z m53 -10
c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m-1469
-88 c-7 -7 -46 9 -46 18 0 5 11 4 25 -2 14 -6 23 -13 21 -16z m41 -8 c-3 -3
-12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m1000 -140 c-3 -3 -12 -4 -19
-1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m90 -10 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6
6 11 1 17 -2 13 -5z m1868 -644 c-27 -12 -43 -12 -25 0 8 5 22 9 30 9 10 0 8
-3 -5 -9z m-50 -19 c-6 -5 -77 -28 -160 -51 -82 -22 -170 -47 -195 -55 -25 -8
-65 -17 -90 -20 -25 -3 -83 -11 -130 -18 -69 -10 -101 -10 -170 0 -47 7 -109
15 -138 18 -30 3 -61 9 -70 14 -10 5 -48 17 -87 26 -82 20 -117 36 -67 31 39
-4 215 -48 222 -56 3 -3 23 -5 45 -6 22 0 81 -2 130 -3 83 -2 258 14 276 25 5
3 25 7 46 9 49 6 154 31 273 66 102 30 130 35 115 20z m-1272 -8 c-7 -2 -19
-2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m313 -318 c17 -13 16 -14 -15 -5
-41 11 -51 20 -25 20 11 0 29 -7 40 -15z m519 5 c-3 -5 -10 -10 -16 -10 -5 0
-9 5 -9 10 0 6 7 10 16 10 8 0 12 -4 9 -10z m-345 -15 c0 -11 11 -15 40 -15
22 0 40 -3 40 -8 0 -4 -35 -4 -77 0 -43 3 -87 7 -97 7 -11 1 -17 3 -14 6 4 5
64 19 101 24 4 1 7 -6 7 -14z m267 9 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1
17 -2 13 -5z m3 -24 c14 -2 -4 -6 -40 -10 -68 -7 -83 -4 -61 9 12 8 31 8 101
1z m530 2 c0 -5 -18 -17 -40 -27 -31 -14 -45 -16 -63 -7 l-22 11 25 1 c14 1
41 8 60 15 19 7 36 14 38 14 1 1 2 -3 2 -7z m-1290 -22 c8 -5 11 -10 5 -10 -5
0 -17 5 -25 10 -8 5 -10 10 -5 10 6 0 17 -5 25 -10z m96 -25 c27 -4 55 -13 63
-19 8 -6 16 -10 18 -8 2 1 13 0 26 -2 12 -3 43 -8 70 -11 26 -3 45 -10 42 -15
-3 -4 1 -11 7 -14 12 -6 -15 -2 -77 9 -11 2 -36 8 -55 13 -19 6 -62 17 -94 26
-33 9 -65 21 -70 27 -8 9 -7 10 5 6 9 -3 38 -9 65 -12z m1069 -4 c-62 -25
-127 -42 -147 -38 -21 4 -20 4 4 6 15 0 31 7 35 15 7 13 42 20 108 24 l20 1
-20 -8z m-185 -52 c13 -9 12 -10 -3 -5 -9 3 -30 1 -45 -5 -28 -11 -106 -24
-231 -39 -80 -9 -258 3 -274 19 -5 5 -17 7 -25 3 -14 -5 -14 -4 -3 9 11 12 28
12 100 4 76 -9 81 -11 46 -16 -27 -4 -8 -7 56 -8 115 -1 208 9 169 19 -19 5
-11 9 40 17 88 14 152 15 170 2z m-287 -26 c-13 -2 -33 -2 -45 0 -13 2 -3 4
22 4 25 0 35 -2 23 -4z"/>
<path d="M5366 5494 c-51 -28 -239 -95 -331 -119 -80 -20 -206 -41 -290 -48
l-30 -2 1 -195 c0 -242 15 -356 66 -529 44 -148 92 -253 168 -363 57 -83 190
-222 235 -245 18 -10 25 -18 17 -21 -7 -2 -24 3 -37 12 -34 22 -45 19 -16 -4
13 -11 36 -20 51 -20 15 0 35 -9 46 -21 l19 -22 -30 7 c-16 4 -31 12 -33 17
-4 11 -32 12 -32 1 0 -4 12 -15 26 -23 17 -10 22 -19 15 -23 -6 -4 -11 -2 -11
3 0 6 -9 11 -20 11 -17 0 -47 35 -42 52 1 3 -5 9 -13 11 -10 4 -12 -1 -9 -21
3 -19 2 -23 -5 -13 -5 7 -14 12 -21 9 -13 -4 65 -58 85 -58 8 0 16 -4 19 -9 4
-5 -2 -8 -11 -7 -10 2 -12 1 -5 -1 6 -3 12 -9 12 -14 0 -6 5 -7 10 -4 6 4 19
-4 29 -16 17 -21 20 -22 35 -7 20 21 21 35 1 18 -9 -7 -19 -10 -23 -6 -10 11
39 45 57 39 12 -3 11 -1 -1 7 -10 6 -18 16 -18 21 0 6 13 1 29 -10 16 -12 33
-21 37 -21 4 0 16 -7 26 -17 14 -13 22 -14 41 -5 46 24 123 68 147 84 18 14
26 15 33 5 6 -8 7 -7 4 5 -4 10 3 22 19 33 55 36 180 164 233 240 140 197 192
324 236 576 20 111 37 341 33 439 l-3 85 -60 7 c-196 25 -450 91 -594 154 -62
28 -58 28 -95 8z m37 -421 c-3 -203 -6 -369 -7 -370 -1 -2 -32 -7 -68 -12 -72
-10 -261 1 -281 17 -6 5 -31 13 -54 17 -22 3 -49 13 -60 20 -20 16 -49 19 -56
8 -2 -5 -2 -2 0 5 3 15 -63 46 -79 36 -7 -5 -9 2 -6 19 3 15 1 28 -5 30 -6 2
-10 87 -11 217 l-1 214 80 12 c142 21 308 64 426 109 62 24 117 44 120 44 3 1
4 -164 2 -366z m-576 -375 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0
-25z m39 -35 c-11 -11 -17 4 -9 23 7 18 8 18 11 1 2 -10 1 -21 -2 -24z m267
10 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m-286 -65 c-3 -7 -5
-2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m410 -720 c-3 -8 -6 -5 -6 6 -1 11
2 17 5 13 3 -3 4 -12 1 -19z"/>
<path d="M5985 4279 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M5952 4230 c-18 -29 -15 -38 4 -12 9 13 14 25 12 27 -2 2 -9 -5 -16
-15z"/>
<path d="M4946 4125 c-6 -17 10 -30 17 -15 3 6 4 5 3 -2 -2 -7 -14 -12 -27
-11 l-24 3 25 -20 c22 -17 26 -18 37 -4 8 12 13 12 19 3 4 -7 2 -15 -4 -17
-21 -7 -13 -28 20 -52 23 -17 30 -19 25 -7 -4 10 -2 16 5 14 6 -1 11 8 13 20
1 12 -2 20 -7 17 -4 -3 -8 -1 -8 3 0 5 -20 25 -44 46 -33 28 -45 33 -50 22z"/>
<path d="M5845 4109 c-11 -17 1 -21 15 -4 8 9 8 15 2 15 -6 0 -14 -5 -17 -11z"/>
<path d="M5050 3990 c0 -14 29 -32 40 -25 6 3 8 10 5 14 -7 12 -45 21 -45 11z"/>
<path d="M5640 3980 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0
-16 -4 -16 -10z"/>
<path d="M5560 3920 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M5594 3892 c6 -10 1 -11 -18 -6 -28 7 -49 -2 -40 -18 4 -7 9 -6 15 3
6 10 13 10 32 2 20 -10 25 -9 23 2 -1 8 -6 18 -11 22 -4 4 -5 2 -1 -5z"/>
<path d="M5554 3835 c-10 -8 -14 -15 -8 -15 6 0 17 7 24 15 16 19 9 19 -16 0z"/>
<path d="M5233 3063 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"/>
<path d="M7371 6789 c-7 -12 -10 -23 -8 -26 3 -3 11 5 17 17 15 28 8 35 -9 9z"/>
<path d="M7343 6710 c-6 -17 -8 -30 -3 -30 8 0 24 50 18 56 -2 2 -9 -10 -15
-26z"/>
<path d="M7032 6710 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M7260 6600 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M7220 6569 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M7180 6550 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
<path d="M7140 6522 c0 -13 72 -103 78 -98 4 5 -68 106 -75 106 -2 0 -3 -4 -3
-8z"/>
<path d="M3070 5979 c0 -5 9 -9 20 -9 11 0 20 2 20 4 0 2 -9 6 -20 9 -11 3
-20 1 -20 -4z"/>
<path d="M3560 5815 c0 -8 7 -15 15 -15 9 0 12 6 9 15 -4 8 -10 15 -15 15 -5
0 -9 -7 -9 -15z"/>
<path d="M3600 5820 c0 -8 50 -24 56 -18 2 2 -10 9 -26 15 -17 6 -30 8 -30 3z"/>
<path d="M6980 5750 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0
-16 -4 -16 -10z"/>
<path d="M3868 5738 c6 -6 18 -8 28 -6 14 3 12 5 -9 10 -19 3 -25 2 -19 -4z"/>
<path d="M3807 5733 c-3 -5 8 -8 25 -9 20 -1 25 2 16 7 -16 11 -35 11 -41 2z"/>
<path d="M8261 4514 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M8073 4045 c-3 -9 -3 -18 -1 -21 3 -3 8 4 11 16 6 23 -1 27 -10 5z"/>
<path d="M7955 3890 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M7891 3741 c-8 -15 -8 -22 1 -27 7 -4 10 -4 6 1 -4 4 -3 14 4 22 6 7
8 16 5 19 -3 3 -10 -3 -16 -15z"/>
<path d="M7320 3140 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M7215 3114 c-16 -13 -34 -24 -40 -24 -5 0 -23 -12 -40 -26 -21 -17
-23 -22 -8 -14 12 5 25 15 28 20 4 6 16 8 27 4 14 -4 18 -2 14 5 -4 6 -2 11 4
11 13 0 55 38 49 44 -2 2 -17 -7 -34 -20z"/>
<path d="M7270 3108 c0 -15 18 -17 30 -3 9 11 8 14 -9 12 -12 -1 -21 -5 -21
-9z"/>
<path d="M7235 3080 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 -8 0
-12 -4 -9 -10z"/>
<path d="M7193 3063 c-23 -4 -34 -43 -13 -43 6 0 9 5 8 12 -2 7 3 13 10 14 6
1 17 2 22 3 6 0 10 6 10 11 0 6 -3 9 -7 9 -5 -1 -18 -4 -30 -6z"/>
<path d="M7135 3030 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M7066 3015 c-11 -8 -16 -15 -10 -15 5 0 18 7 28 15 11 8 16 15 10 15
-5 0 -18 -7 -28 -15z"/>
<path d="M7036 2987 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M6985 2967 c-47 -28 -48 -29 -34 -39 9 -5 4 -6 -15 -2 -19 5 -27 3
-23 -3 4 -6 -4 -14 -18 -17 -42 -11 -28 -24 16 -16 38 7 89 40 61 40 -16 0
-16 20 1 20 6 0 21 7 31 15 23 17 10 18 -19 2z"/>
<path d="M7030 2950 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M6983 2915 c-32 -31 -29 -37 7 -17 16 9 30 23 30 30 0 17 -11 13 -37
-13z"/>
<path d="M6905 2870 c-8 -13 15 -13 35 0 12 8 11 10 -7 10 -12 0 -25 -4 -28
-10z"/>
<path d="M6710 2811 c0 -5 9 -7 20 -4 11 3 20 7 20 9 0 2 -9 4 -20 4 -11 0
-20 -4 -20 -9z"/>
<path d="M6785 2800 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"/>
<path d="M6664 2785 c-10 -8 -14 -15 -9 -15 14 -2 -26 -18 -45 -19 -13 -1 -13
0 0 10 11 8 9 9 -10 3 -14 -4 -26 -11 -28 -15 -2 -5 -11 -9 -20 -9 -14 0 -15
-2 -3 -9 12 -8 12 -13 3 -24 -10 -12 -9 -16 2 -20 10 -4 13 -1 10 8 -4 10 0
12 16 8 11 -3 28 1 38 9 9 8 31 20 47 27 17 8 24 16 18 18 -9 3 -10 10 -3 24
13 23 10 24 -16 4z m-54 -61 c0 -2 -7 -4 -15 -4 -8 0 -15 4 -15 10 0 5 7 7 15
4 8 -4 15 -8 15 -10z"/>
<path d="M6710 2769 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M6505 2720 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M6422 2688 c3 -7 12 -14 22 -14 15 -2 15 -2 0 3 -14 4 -14 7 -3 14
11 7 10 9 -4 9 -11 0 -17 -6 -15 -12z"/>
<path d="M6505 2680 c3 -5 14 -10 23 -10 15 0 15 2 2 10 -20 13 -33 13 -25 0z"/>
<path d="M6397 2669 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M6335 2660 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
-13 -4 -16 -10z"/>
<path d="M6465 2663 c-11 -3 -24 -10 -30 -15 -7 -7 -2 -8 15 -3 52 15 64 30
15 18z"/>
<path d="M6390 2640 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z"/>
<path d="M6200 2590 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M6143 2583 c9 -2 17 -9 17 -14 0 -6 5 -7 11 -3 14 8 -8 24 -31 23
-11 -1 -10 -3 3 -6z"/>
<path d="M6080 2570 c0 -6 -10 -15 -22 -20 -21 -8 -21 -9 -3 -9 11 -1 26 8 33
19 7 12 8 20 2 20 -5 0 -10 -5 -10 -10z"/>
<path d="M5978 2533 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
